import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const InstitutionalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 1200px;

  @media (max-width: ${screenSizes.mobile}) {
    gap: 1.5rem;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;

  @media (max-width: ${screenSizes.mobile}) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const Section = styled.section`
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;

  h3 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 1.5rem 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i {
      color: #2563eb;
    }
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 1.5rem;
  }
`;
